import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    lessonByTopic: null,
    topics: null,
    studyGroup: null
};

const topicsSlice = createSlice({
    name: "topics",
    initialState,
    reducers: {
        initTopics(state, action) {
            state.topics = action.payload.topics
            state.lessonByTopic = action.payload.lessonByTopic
        },
        initStudyGroup(state, action) {
            state.studyGroup = action.payload.studyGroup;
        }
    }
})

export const topicsAction = topicsSlice.actions;
export default topicsSlice;